'use strict';

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
function g(e,n,i){if(typeof n=="string")for(;e.indexOf(n)>-1;){let t=typeof i=="function"?i(n):i;e=e.replace(n,t);}else {let t;if(!n.global)throw new Error("The search parameter must be enabled '/g' option");for(;(t=n.exec(e))!==null;){t.index===n.lastIndex&&n.lastIndex++;let r=typeof i=="function"?i(t[0],...t):i;e=e.replace(t[0],r);}}return e}String.prototype.replaceAll||(String.prototype.replaceAll=function(e,n){return g(this,e,n)});

exports.a = g;
